module.exports = __webpack_public_path__ + "img/book.f5296603.svg";